import type { Copy } from "../types";

export const da: Copy = {
    seo: {
      title: "Bilalderberegner | Tjek køretøjets alder efter år og måned",
      description:
        "Tjek et køretøjs alder ud fra produktionsår og valgfri måned. Se år, måneder, dage, samlet antal dage og milepæle.",
      keywords: [
        "bilalderberegner",
        "køretøjsalder beregner",
        "bilens produktionsår",
        "køretøjets produktionsmåned",
        "hvor gammel er min bil",
        "bilalder efter år",
        "tjek køretøjsalder",
        "RC alder beregner",
        "bilalder efter måned",
        "køretøjsdato beregner",
        "mParivahan alternativ",
        "Parivahan alternativ",
        "RTO køretøjsalder beregner",
        "tjek registreringsalder",
        "køretøjets registreringsalder",
      ],
      faq: [
        {
          question: "Hvad gør denne beregner?",
          answer:
            "Den beregner den nøjagtige alder for et køretøj ud fra valgt produktionsår og valgfri måned og viser år, måneder, dage og milepæle.",
        },
        {
          question: "Hvorfor er måneden valgfri?",
          answer:
            "Måneden giver en mere præcis aldersberegning. Hvis du springer den over, bruger appen januar i det valgte år.",
        },
        {
          question: "Kan jeg vælge et fremtidigt år eller en fremtidig måned?",
          answer:
            "Nej. Fremtidige år blokeres, og fremtidige måneder deaktiveres, når det valgte år er indeværende år.",
        },
      ],
    },
    headerTagline: "Køretøjsværktøj",
    headerTitle: "Bilalderberegner",
    reset: "Nulstil",
    switchToLight: "Skift til lys tilstand",
    switchToDark: "Skift til mørk tilstand",
    languageLabel: "Sprog",
    languageEnglish: "Engelsk",
    languageHindi: "Hindi",
    heroEyebrow: "Bilalder, tydeligt",
    heroTitle: "Et enkelt datoværktøj til køretøjets alder.",
    heroDescription:
      "Vælg produktionsår. Tilføj kun måned, hvis du ønsker et mere præcist aldersresultat.",
    yearSelectLabel: "Produktionsår",
    monthSelectLabel: "Produktionsmåned",
    includeMonthLabel: "Medtag specifik måned for mere præcision",
    includeMonthNote:
      "Hvis du ikke medtager en måned, bruges januar i beregningen.",
    yearOnlyBadge: "Kun år",
    yearMonthBadge: "År + måned",
    yearPlaceholder: "Vælg år",
    monthPlaceholder: "Vælg måned",
    inputTitle: "Produktionsår",
    inputLabel: "Produktionsår",
    blockedDateNote: "Fremtidige år er blokeret.",
    result: "Resultat",
    vehicleAgeLead: "Dit køretøj er",
    asOfToday: "Pr. i dag",
    years: "År",
    months: "Måneder",
    days: "Dage",
    totalDays: (count) => `${count.toLocaleString("da-DK")} dage i alt`,
    ageLabels: {
      almostNew: "Næsten nyt",
      modern: "Moderne",
      mature: "Modent",
      classic: "Klassisk",
    },
    estimatedValue: {
      high: "Højt videresalgspotentiale",
      healthy: "God værdifastholdelse",
      moderate: "Moderat afskrivning",
      collector: "Samlerinteressen kan vokse",
    },
    maintenanceTitle: "Vedligeholdelse",
    maintenance: {
      routine: "Rutineservice og OEM-vedligeholdelse",
      watch: "Hold øje med bremser, væsker og dæk",
      plan: "Planlæg sliddele og eftersyn",
      specialized: "Specialiseret vedligeholdelse bliver værdifuld",
    },
    registrationTitle: "Registrering",
    registration: {
      collector: "Kan kvalificere til samlerlignende behandling i visse regioner",
      classic: "Klassisk bilregistrering kan gælde i visse regioner",
      standard: "Forvent standardfornyelser og regionale kontroller",
      regular: "Almindelig registrering gælder normalt",
    },
    upcomingMilestoneTitle: "Kommende milepæl",
    milestoneTimelineTitle: "Milepælstidslinje",
    milestoneRemaining: ({ label, days }) => `${label} om ${days.toLocaleString("da-DK")} dage`,
    reached: "Nået",
    upcoming: "Kommende",
    allMilestonesReachedTitle: "Alle viste milepæle er nået",
    allMilestonesReachedBody:
      "Dette køretøj har passeret det milepælsområde, der aktuelt vises i appen.",
    copySummary: "Kopiér oversigt",
    shareResult: "Del resultat",
    resetMessage: "Beregneren er nulstillet",
    summaryCopied: "Oversigt kopieret til udklipsholderen",
    clipboardFailed: "Adgang til udklipsholder mislykkedes",
    emptyTitle: "Vælg et produktionsår for at få hele oversigten",
    emptyDescription:
      "Når et år er valgt, ser du nøjagtig alder, samlet antal dage, vedligeholdelsesnoter, klassikerstatus og milepæle.",
    shareTitle: "Bilalderberegner",
    summary: ({ label, years, months, days, asOf }) =>
      `Min bil blev produceret i ${label} og er ${years} år, ${months} måneder og ${days} dage gammel pr. ${asOf}.`,
    milestones: {
      1: { label: "Første år", note: "Nyttigt til garanti- og serviceplanlægning." },
      3: { label: "Tre år", note: "Et almindeligt tidspunkt for videresalg og værdiændringer." },
      5: { label: "Fem år", note: "Godt tidspunkt til mere detaljeret vedligeholdelsesbudget." },
      10: { label: "Ti år", note: "Aldrende komponenter kræver ekstra opmærksomhed." },
      15: { label: "Femten år", note: "Mange regioner begynder klassikerbehandling her." },
      25: { label: "Femogtyve år", note: "Samler- og importinteresse kan vokse på nogle markeder." },
    },
  };
